import React from "react";
import { Box } from "@chakra-ui/react";
export function ButtonGroup(props) {
    return React.createElement(Box, { display: "flex", gap: 3, ...props });
}
